import Utils from "./Utils";

// Fallbacks so Netlify works without env vars (keys were previously in repo)
const FMP_KEY =
  process.env.REACT_APP_FMP_API_KEY || "8b810aa6171c1da8c17b5fec32a6b0da";
const FINHUB_KEY =
  process.env.REACT_APP_FINHUB_API_KEY || "brnrl2nrh5reu6jtdjlg";
const ALPHAVANTAGE_KEY =
  process.env.REACT_APP_ALPHAVANTAGE_API_KEY || "AUNVOSKPA82VLHO5";
const GOOGLE_SEARCH_KEY = process.env.REACT_APP_GOOGLE_SEARCH_API_KEY || "AIzaSyD00Q6yd8dRIy9jn1Izx1lLg3KZIybf7Yw";
const GOOGLE_SEARCH_CX = process.env.REACT_APP_GOOGLE_SEARCH_CX || "61b0636005bdb725a";

export const API_KEYS = {
  FMP_API_KEY: `apikey=${FMP_KEY}`,
  FINHUB_API_KEY: `token=${FINHUB_KEY}`,
  ALPHAVANTAGE_API_KEY: `apikey=${ALPHAVANTAGE_KEY}`,
  GOOGLE_SEARCH_API_KEY: `key=${GOOGLE_SEARCH_KEY}&cx=${GOOGLE_SEARCH_CX}`,
};

export const FMP_API_ENDPOINTS = {
  BASE_URL: "https://financialmodelingprep.com/api/v3",
  STABLE_URL: "https://financialmodelingprep.com/stable",

  QUOTE: (symbols) => `${FMP_API_ENDPOINTS.BASE_URL}/quote/${symbols}`,
  PROFILE: (symbol) => `${FMP_API_ENDPOINTS.BASE_URL}/profile/${symbol}`,
  PRICE_HISTORY: (symbol) =>
    `${FMP_API_ENDPOINTS.BASE_URL}/historical-price-full/${symbol}`,
  STOCK_GRADE: (symbol) =>
    `${FMP_API_ENDPOINTS.STABLE_URL}/grades?symbol=${symbol}&limit=10`,
  STOCK_NEWS: (symbol) =>
    `${FMP_API_ENDPOINTS.STABLE_URL}/news/stock?symbols=${symbol}&limit=10`,

  ETF_PROFILE: (symbol) =>
    `${FMP_API_ENDPOINTS.STABLE_URL}/etf/info?symbol=${symbol}`,

  ETF_HOLDINGS: (symbol) =>
    `${FMP_API_ENDPOINTS.BASE_URL}/etf-holder/${symbol}`,
  ETF_SECTOR: (symbol) =>
    `${FMP_API_ENDPOINTS.BASE_URL}/etf-sector-weightings/${symbol}`,
  ETF_COUNTRY: (symbol) =>
    `${FMP_API_ENDPOINTS.BASE_URL}/etf-country-weightings/${symbol}`,

  QUOTE_SHORT: (symbol) =>
    `${FMP_API_ENDPOINTS.BASE_URL}/quote-short/${symbol}`,
  INDEX: () => `${FMP_API_ENDPOINTS.BASE_URL}/quotes/index`,
  GOLD: () => `${FMP_API_ENDPOINTS.BASE_URL}/quote/GCUSD`,
  SILVER: () => `${FMP_API_ENDPOINTS.BASE_URL}/quote/SIUSD`,
  OIL: () => `${FMP_API_ENDPOINTS.BASE_URL}/quote/CLUSD`,
  CRYPTO: () => `${FMP_API_ENDPOINTS.BASE_URL}/quote/BTCUSD`,
  MOST_ACTIVE: () => `${FMP_API_ENDPOINTS.BASE_URL}/actives`,
  MOST_GAINERS: () => `${FMP_API_ENDPOINTS.BASE_URL}/gainers`,
  MOST_LOSERS: () => `${FMP_API_ENDPOINTS.BASE_URL}/losers`,

  /** @param {string} date YYYY-MM-DD @param {string} [exchange] e.g. NYSE, NASDAQ */
  SECTOR_PERFORMANCE_SNAPSHOT: (date, exchange) => {
    let q = `date=${encodeURIComponent(date)}`;
    if (exchange) q += `&exchange=${encodeURIComponent(exchange)}`;
    return `${FMP_API_ENDPOINTS.STABLE_URL}/sector-performance-snapshot?${q}`;
  },
};

const DEFAULT_GOOGLE_CLIENT_ID =
  "17726506230-ilk8h2deqvko7emhb7dsiobe4g2guvjn.apps.googleusercontent.com";

const Constants = {
  GOOGLE_CLIENT_ID:
    process.env.REACT_APP_GOOGLE_CLIENT_ID || DEFAULT_GOOGLE_CLIENT_ID,

  NEWS_URL:
    "https://financialmodelingprep.com/api/v4/general_news?" +
    API_KEYS.FMP_API_KEY,

  FETCH_PRICES_URL: Utils.getServerURL() + "fetchPrices/",
  STORE_VALES_URL: Utils.getServerURL() + "runDailyReport/",
  COMPARE_TCKRS_URL: Utils.getServerURL() + "cmprCompTckrs/",
  SCREENER_URL: Utils.getServerURL() + "screener/",
  PORTFOLIO_URL: Utils.getServerURL() + "portfolio/",
  COATTAIL_URL: Utils.getServerURL() + "coattail/",
  SECTOR_SCREENER_URL: Utils.getServerURL() + "sector/",
  INDUSTRY_SCREENER_URL: Utils.getServerURL() + "industry/",
  COUNTRY_URL: Utils.getServerURL() + "country/",
  PERFORMANCE_URL: Utils.getServerURL() + "performance/",
  EARNINGS_CAL_URL: Utils.getServerURL() + "earningsCalendar/",
  ACTIVITY_URL: Utils.getServerURL() + "activity/",
  DEEPDIVE_URL: Utils.getServerURL() + "companyDeepdives/",
  DEEPDIVE_ALL_URL: Utils.getServerURL() + "deepdiveReport/",
  RECENT_IPOS_URL: Utils.getServerURL() + "recentIPOs/",

  SERVICE_URL: Utils.getServerURL() + "search/",
  SYMBOL_LIST_URL: Utils.getServerURL() + "symbolsList",
  VALIDATE_URL: Utils.getServerURL() + "validate/",
  ACCESS_REQUEST_URL: Utils.getServerURL() + "accessRequest/",
  FEATURE_REQUEST_URL: Utils.getServerURL() + "featureRequest/",
  ADD_TO_FAVORITES_URL: Utils.getServerURL() + "addToFavorites/",
  REMOVE_FROM_FAVORITES_URL: Utils.getServerURL() + "removeFromFavorites/",
  FAVORITES_URL: Utils.getServerURL() + "findFavorites/",
  LEADERS_URL: Utils.getServerURL() + "gainers/",
  INITIALIZE_URL: Utils.getServerURL() + "initialize",
  RUN_DCF_REFRESH_JOB_URL: Utils.getServerURL() + "run_dcf_refresh_job",

  BLOG_URL: "https://pkkishore.wixsite.com/simplystock",
  IMAGE_URL: "https://financialmodelingprep.com/image-stock/",

  NEWS_URL2:
    "https://finnhub.io/api/v1/news?category=general&token=brnrl2nrh5reu6jtdjlg",
  RECOMMENDATIONS_URL:
    "https://finnhub.io/api/v1/stock/recommendation?" + API_KEYS.FINHUB_API_KEY,
  TARGET_PRICE_URL:
    "https://finnhub.io/api/v1/stock/price-target?" + API_KEYS.FINHUB_API_KEY,
  IPO_URL: "https://finnhub.io/api/v1/calendar/ipo?" + API_KEYS.FINHUB_API_KEY,
  SENTIMENT_URL:
    "https://finnhub.io/api/v1/news-sentiment?" + API_KEYS.FINHUB_API_KEY,
  SECTOR_URL:
    "https://www.alphavantage.co/query?function=SECTOR&" +
    API_KEYS.ALPHAVANTAGE_API_KEY,
  MA_URL:
    "https://www.alphavantage.co/query?series_type=close&" +
    API_KEYS.ALPHAVANTAGE_API_KEY,
};

export default Constants;
